import * as loadImage from 'blueimp-load-image';
import * as React from 'react';

export interface ThumbnailProps {
    src: string;
    thumbnail?: string;
    maxWidth?: number;
    maxHeight?: number;
    contain?: boolean;
}

const options = {
    canvas: true,
    orientation: true
};

const loadCanvas = async (props: ThumbnailProps) => new Promise<HTMLCanvasElement>((res, _) => {
    loadImage(
        props.thumbnail || props.src,
        (canvas, __) => {
            res(canvas as HTMLCanvasElement);
        },
        { ...options,  ...props} as any);

});

/**
 * Thumbnail control
 */
export class Thumbnail extends React.Component<ThumbnailProps> {
    private container: HTMLAnchorElement;

    constructor(props: ThumbnailProps) {
        super(props);
        this.setContainer = this.setContainer.bind(this);
    }

    public async componentDidMount() {
        await this.renderImage();
    }

    public async componentDidUpdate(prevProps: ThumbnailProps) {
        if (this.props.src === prevProps.src) {
            return;
        }

        await this.renderImage();
    }

    public render() {
        return <a ref={this.setContainer} href={this.props.src} className='loaded-image-container' role='button'/>;
    }

    private async renderImage() {
        while (this.container.firstChild) {
            this.container.removeChild(this.container.firstChild);
        }

        const canvas = await loadCanvas(this.props);

        this.container?.appendChild(canvas);
    }

    private setContainer(el: HTMLAnchorElement) {
        this.container = el;
    }
}
